import {ReactElement, useState} from "react";
import styled from "styled-components";

import {BlocContent} from "@/components/BlocContent/BlocContent";
import {Button} from "@/components/Button/Button";
import {ErrorMessage} from "@/components/ErrorMessage/ErrorMessage";
import {TableauKpiEnCours} from "@/components/Kpi/KpiEnCours/TableauKpiEnCours";
import {TableauAvancement} from "@/components/TableauAvanacement/TableauAvancement";
import {Title} from "@/components/Title/Title";
import {AppContext} from "@/context/AppContext";
import {HookFormContext, HookFormContextType} from "@/context/HookFormContext";
import {getAvancement} from "@/fonction/calcule";
import {useButtonToDownloadContrat} from "@/hooks/useButtonToDownloadContrat/useButtonToDownoloadContrat";
import {useGetContext} from "@/hooks/useGetContext/useGetContext";
import {AppContext as AppContextType} from "@/ts/appContext";
import {Contrat} from "@/ts/contrat";

const ContentAvencement = styled.div<{$isDisabled: boolean}>`
  margin: 30px auto;
  width: fit-content;
  opacity: ${({$isDisabled}) => ($isDisabled ? 0.6 : 1)};
  cursor: ${({$isDisabled}) => ($isDisabled ? "not-allowed" : "pointer")};
`;

export function BlocSuiviContrat({
  contrat: contratFromProps,
  ...props
}: {
  contrat: Contrat;
  [key: string]: any;
}): ReactElement {
  const {API} = useGetContext<AppContextType>(AppContext, "AppContext");

  const {getValues} = useGetContext<HookFormContextType>(
    HookFormContext,
    "HookFormContext"
  );
  const [contrat, setContrat] = useState<Contrat>(contratFromProps);

  const {label, icon, title, variant, handleClick} = useButtonToDownloadContrat(
    {
      contrat,
      API,
      currentContremarque: contrat?.adherent?.contremarque,
    }
  );

  return (
    <>
      <BlocContent isDisabled={contrat?.statut === "cloture"}>
        <Title
          title={`${contrat?.statut === "cloture" ? `CONTRAT CLOTURÉ -  ${contrat?.adherent?.nom}` : `Contrat ${contrat?.adherent?.nom} - Suivi des KPI`}`}>
          <Button
            label={label}
            icon={icon}
            title={title}
            variant={variant}
            onClick={handleClick}
          />
        </Title>

        {contrat?.statut === "actif" || contrat?.statut === "cloture" ? (
          <>
            <TableauKpiEnCours
              contrat={contrat}
              refreshAllNotifications={props?.refreshAllNotifications}
              refreshContrat={setContrat}
            />
            <ContentAvencement $isDisabled={contrat?.statut === "cloture"}>
              {contrat?.campagne?.bonus.length > 0 ? (
                <TableauAvancement
                  avancement={getAvancement(
                    contrat,
                    contrat?.campagne?.bonus?.sort(
                      (a, b) => a.seuil_ca - b.seuil_ca
                    )[getValues("selected_bonus")?.value || 0]
                  )}
                />
              ) : (
                <ErrorMessage text="Aucun bonus trouvé" />
              )}
            </ContentAvencement>
          </>
        ) : null}
      </BlocContent>
    </>
  );
}
